/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerNaturalPersonDto } from './BorrowerNaturalPersonDto';
import {
    BorrowerNaturalPersonDtoFromJSON,
    BorrowerNaturalPersonDtoFromJSONTyped,
    BorrowerNaturalPersonDtoToJSON,
    BorrowerNaturalPersonDtoToJSONTyped,
} from './BorrowerNaturalPersonDto';
import type { LegalEntityDto } from './LegalEntityDto';
import {
    LegalEntityDtoFromJSON,
    LegalEntityDtoFromJSONTyped,
    LegalEntityDtoToJSON,
    LegalEntityDtoToJSONTyped,
} from './LegalEntityDto';
import type { SaveAnswerCommandDto } from './SaveAnswerCommandDto';
import {
    SaveAnswerCommandDtoFromJSON,
    SaveAnswerCommandDtoFromJSONTyped,
    SaveAnswerCommandDtoToJSON,
    SaveAnswerCommandDtoToJSONTyped,
} from './SaveAnswerCommandDto';

/**
 * 
 * @export
 * @interface UpsertBorrowerPersonCommandDto
 */
export interface UpsertBorrowerPersonCommandDto {
    /**
     * 
     * @type {BorrowerNaturalPersonDto}
     * @memberof UpsertBorrowerPersonCommandDto
     */
    naturalPerson?: BorrowerNaturalPersonDto;
    /**
     * 
     * @type {LegalEntityDto}
     * @memberof UpsertBorrowerPersonCommandDto
     */
    legalEntity?: LegalEntityDto;
    /**
     * 
     * @type {SaveAnswerCommandDto}
     * @memberof UpsertBorrowerPersonCommandDto
     */
    saveAnswersCommand: SaveAnswerCommandDto;
    /**
     * Existing outstanding amount (excluding this project), in euros
     * @type {number}
     * @memberof UpsertBorrowerPersonCommandDto
     */
    existingOutstanding?: number | null;
}

/**
 * Check if a given object implements the UpsertBorrowerPersonCommandDto interface.
 */
export function instanceOfUpsertBorrowerPersonCommandDto(value: object): value is UpsertBorrowerPersonCommandDto {
    if (!('saveAnswersCommand' in value) || value['saveAnswersCommand'] === undefined) return false;
    return true;
}

export function UpsertBorrowerPersonCommandDtoFromJSON(json: any): UpsertBorrowerPersonCommandDto {
    return UpsertBorrowerPersonCommandDtoFromJSONTyped(json, false);
}

export function UpsertBorrowerPersonCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertBorrowerPersonCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'naturalPerson': json['naturalPerson'] == null ? undefined : BorrowerNaturalPersonDtoFromJSON(json['naturalPerson']),
        'legalEntity': json['legalEntity'] == null ? undefined : LegalEntityDtoFromJSON(json['legalEntity']),
        'saveAnswersCommand': SaveAnswerCommandDtoFromJSON(json['saveAnswersCommand']),
        'existingOutstanding': json['existingOutstanding'] == null ? undefined : json['existingOutstanding'],
    };
}

export function UpsertBorrowerPersonCommandDtoToJSON(json: any): UpsertBorrowerPersonCommandDto {
    return UpsertBorrowerPersonCommandDtoToJSONTyped(json, false);
}

export function UpsertBorrowerPersonCommandDtoToJSONTyped(value?: UpsertBorrowerPersonCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'naturalPerson': BorrowerNaturalPersonDtoToJSON(value['naturalPerson']),
        'legalEntity': LegalEntityDtoToJSON(value['legalEntity']),
        'saveAnswersCommand': SaveAnswerCommandDtoToJSON(value['saveAnswersCommand']),
        'existingOutstanding': value['existingOutstanding'],
    };
}

